type DebounceFn<T extends unknown[]> = (...args: T) => void

export const debounce = <T extends unknown[]>(
    func: (...args: T) => void,
    delay: number,
    leading = false
): DebounceFn<T> => {
    let timeoutId: ReturnType<typeof setTimeout> | null = null
    let called = false

    return (...args: T) => {
        if (timeoutId) {
            clearTimeout(timeoutId)
        }
        if (leading && !called) {
            func(...args)
            called = true
        }
        timeoutId = setTimeout(() => {
            if (!leading) func(...args)
            called = false
        }, delay)
    }
}
